import React, { useState } from "react";
import { User } from "../../global-components/src/types";
import { ChatMessageReaction } from "../../types";
import { getImagePathBucketPacoca } from "../../global-components/src/utils/utils";
import { X } from "lucide-react";
import { ReactionEmoji } from "./reaction-emoji";
import "./chat-reactions.css";

interface Props {
    reactions: ChatMessageReaction[];
    currentUserId?: number;
    onClose: () => void;
    onRemoveReaction?: () => void;
}

export const ChatReactionsModal: React.FC<Props> = ({
    reactions,
    currentUserId,
    onClose,
    onRemoveReaction,
}) => {
    const [selectedTab, setSelectedTab] = useState<string>("all");

    // Group reactions by emoji
    const emojiCounts: { [emoji: string]: number } = {};
    reactions.forEach((r) => {
        emojiCounts[r.emoji] = (emojiCounts[r.emoji] || 0) + 1;
    });

    const uniqueEmojis = Object.keys(emojiCounts);

    const filteredReactions = selectedTab === "all"
        ? reactions
        : reactions.filter((r) => r.emoji === selectedTab);

    return (
        <div className="chat-reactions-modal-backdrop" onClick={onClose}>
            <div className="chat-reactions-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="chat-reactions-modal-header">
                    <div className="chat-reactions-tabs">
                        <button
                            type="button"
                            className={`chat-reactions-tab ${selectedTab === "all" ? "active" : ""}`}
                            onClick={() => setSelectedTab("all")}
                        >
                            Todas {reactions.length}
                        </button>
                        {uniqueEmojis.map((emoji) => (
                            <button
                                key={emoji}
                                type="button"
                                className={`chat-reactions-tab ${selectedTab === emoji ? "active" : ""}`}
                                onClick={() => setSelectedTab(emoji)}
                            >
                                <span className="tab-emoji">
                                    <ReactionEmoji emoji={emoji} size={18} />
                                </span>
                                <span className="tab-count">{emojiCounts[emoji]}</span>
                            </button>
                        ))}
                    </div>
                    <button type="button" className="chat-reactions-close-btn" onClick={onClose}>
                        <X size={18} />
                    </button>
                </div>

                <div className="chat-reactions-list">
                    {filteredReactions.map((r, idx) => {
                        const isMe = r.user_id === currentUserId;
                        return (
                            <div key={idx} className="chat-reaction-item">
                                <div className="chat-reaction-user-info">
                                    <img
                                        src={getImagePathBucketPacoca(r.user?.img_account)}
                                        onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}
                                        alt={r.user?.name || ""}
                                        className="chat-reaction-avatar"
                                    />
                                    <div className="chat-reaction-user-names">
                                        <span className="chat-reaction-user-name">
                                            {isMe ? "Você" : r.user?.name || "Usuário"}
                                        </span>
                                        {isMe && onRemoveReaction && (
                                            <button
                                                type="button"
                                                className="chat-reaction-remove-btn"
                                                onClick={() => {
                                                    onRemoveReaction();
                                                    onClose();
                                                }}
                                            >
                                                Clique para remover
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <span className="chat-reaction-item-emoji">
                                    <ReactionEmoji emoji={r.emoji} size={22} />
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
